<template lang="pug">
  #choose-organization
    WtTile(v-if="!memberLoaded || isPartOfOrganization")
      BLoading(
        :active="!memberLoaded || isPartOfOrganization"
        is-full-page
      )
    WtTile(v-else vertical)
      WtTitle(size="h1") {{_.get(coreProgramMeta, "organizationsName", "Organization")}}
      WtTile(ancestor vertical child)
          WtTitle.mb-1 Your {{_.get(coreProgramMeta, "organizationsName", "Organization")}}
          p.has-text-black.is-size-7 You are not part of an {{_.get(coreProgramMeta, "organizationsName", "Organization")}} yet.
          WtTile.mt-2
            BDropdown(
              v-model="organizationSelected"
            ).mr-3
              .sort-by-trigger(slot="trigger" slot-scope="{ active }")
                BButton.organizations-dropdown(
                  :label="organizationSelected ? _.find(organizations, {id:organizationSelected}).name : `Select Your ${_.get(coreProgramMeta, 'organizationsName', 'Organization')}`"
                  :icon-right="active ? 'chevron-up' : 'chevron-down'"
                )
              BDropdownItem(
                :value="0"
              ) None
              template(
                v-for="organization in organizations"
                v-if="organization.active"
                )
                BDropdownItem(
                  :value="organization.id"
                ) {{organization.name}}
            BButton(
              v-on:click="confirmJoinOrganization"
              :disabled="!organizationSelected"
              type="is-primary"
            ) Confirm
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import { mapActions, mapGetters } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";

export default {
  name: "ChooseOrganization",

  components: {
    WtTitle,
    WtTile
  },

  data() {
    return {
      organizationSelected: null
    };
  },

  computed: {
    ...mapGetters("members", ["member", "memberLoaded"]),
    ...mapGetters("program", ["coreProgramMeta"]),
    ...mapGetters("organizations", ["organizations"]),

    isPartOfOrganization() {
      return !!(
        this.memberLoaded && this._.get(this.member, "organizationId", false)
      );
    }
  },

  watch: {
    memberLoaded() {
      if (this.memberLoaded) {
        this.goToOrganizationPageDecision();
      }
    }
  },

  mounted() {
    this.goToOrganizationPageDecision();
  },

  methods: {
    ...mapActions("organizations", ["joinOrganization"]),

    goToOrganizationPageDecision() {
      if (
        this.isPartOfOrganization &&
        this._.get(this.member, "organizationData.name", false)
      ) {
        this.$router.push({
          name: "Organization",
          params: { organizationName: this.member.organizationData.name }
        });
      }
    },
    async confirmJoinOrganization() {
      const response = await this.joinOrganization(this.organizationSelected);
      this.$router.push({
        name: "Organization",
        params: { organizationName: response.data.data.name }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
#choose-organization
  .organizations-dropdown
    min-width: 250px
    display: flex
    justify-content: space-between
</style>
